import _ from "lodash";

import { LOCAL_CURRENCY } from "@/utils/constants";
import { SalaryIncomeFrequency } from "prisma/cm/client";

import { FieldValueResolver } from "../fields/FieldValueResolver";

export function getCurrencyField(
  tableRowModel: "Proposal" | "User" | "Range" | "proposal" | "user" | "range",
) {
  switch (tableRowModel) {
    case "User":
    case "user":
      return "salaryCurrencyCode";
    case "Proposal":
    case "proposal":
      return "owner.salaryCurrencyCode";
    case "Range":
    case "range":
      return "salaryCurrencyCode";
    default:
      throw Error("Invalid table row model");
  }
}

export function getCurrencyOffInstance(instance: any): string {
  if (FieldValueResolver.validateAsProposal(instance)) {
    const path = getCurrencyField("Proposal");
    return _.get(instance, path) as string;
  } else if (FieldValueResolver.validateAsUser(instance)) {
    const path = getCurrencyField("User") as string;
    return _.get(instance, path);
  } else if (FieldValueResolver.validateAsRange(instance)) {
    const path = getCurrencyField("Range") as string;
    return _.get(instance, path);
  } else {
    const inferredCurrency = _.get(instance, "currencyCode", null);
    if (!inferredCurrency) {
      throw Error(`Invalid dont know how to get currency on ${instance.explicit_kind}`);
    }
    return inferredCurrency;
  }
}

export function treatLocalCurrencyAs(
  currency: string | null | undefined,
  fallbackCurrency: string,
): string {
  if (!currency) {
    return "NOT_REAL_CURRENCY";
  }

  return currency === LOCAL_CURRENCY ? fallbackCurrency : currency;
}

export function getSalaryFrequencyOffInstance(instance: any): SalaryIncomeFrequency {
  if (FieldValueResolver.validateAsProposal(instance)) {
    if (instance.salaryIncomeFrequency) {
      return instance.salaryIncomeFrequency;
    } else if (instance.owner?.salaryIncomeFrequency) {
      return instance.owner.salaryIncomeFrequency;
    } else {
      throw new Error("No salary income frequency found");
    }
  } else if (FieldValueResolver.validateAsUser(instance)) {
    if (instance.salaryIncomeFrequency) {
      return instance.salaryIncomeFrequency;
    } else {
      throw new Error("No salary income frequency found");
    }
  } else if (FieldValueResolver.validateAsRange(instance)) {
    if (instance?.salaryIncomeFrequency) {
      return instance.salaryIncomeFrequency;
    } else {
      throw new Error("No salary income frequency found");
    }
  } else {
    throw new Error("Invalid instance");
  }
}
